export const FETCH_PROVIDERS = 'FETCH_PROVIDERS' as 'FETCH_PROVIDERS';
export const FETCH_PROVIDERS_SUCCESS = 'FETCH_PROVIDERS_SUCCESS' as 'FETCH_PROVIDERS_SUCCESS';
export const FETCH_PROVIDERS_FAIL = 'FETCH_PROVIDERS_FAIL' as 'FETCH_PROVIDERS_FAIL';
export const FETCH_PROVIDERS_CANCEL = 'FETCH_PROVIDERS_CANCEL' as 'FETCH_PROVIDERS_CANCEL';
export const CLEAR_PROVIDERS = 'CLEAR_PROVIDERS' as 'CLEAR_PROVIDERS';

export const FETCH_PROVIDERS_PAGE = 'FETCH_PROVIDERS_PAGE' as 'FETCH_PROVIDERS_PAGE';
